import { render, staticRenderFns } from "./OpendataChecklist.vue?vue&type=template&id=2eac2ae2&"
import script from "./OpendataChecklist.vue?vue&type=script&lang=js&"
export * from "./OpendataChecklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports